module.exports = __webpack_public_path__ + "static/media/piscina.bdca3dc2.png";